<template>
  <div class="h-screen flex w-full" id="page-login">
    <div class="w-full sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row">
            <div class="hidden h-screen lg:block lg:w-2/3 flex items-center">
              <div class="h-full flex item-center">
                <img src="@/assets/images/slider/meeting.svg" alt="login" class="m-auto">
              </div>
            </div>
            <div class="sm:w-full h-screen md:w-full lg:w-1/3 d-theme-dark-bg">
              <div class="h-full flex item-center">
                <div class="px-8 m-auto">
                  <div class="text-center flex justify-center mb-16 lg:mb-20 md:mb-20 sm:mb-6">
                    <img src="@/assets/images/logo/r_logo.svg" alt="login" class="md:w-2/5 lg:w-3/4 sm:w-2/5 w-3/4 text-center">
                  </div>
                  <div class="vx-card__title lg:mt-4 md:mt-4">
                    <h4 class="title font-bold text-2xl text-center">Bienvenido a Robocob</h4>
                    <p class="mt-4 mb-4 sm:mt-1 sm:mb-1">Por favor ingresa a tu cuenta</p>
                  </div>
                  <div>
                    <vs-input
                        name="email"
                        icon-no-border
                        icon="icon icon-user"
                        icon-pack="feather"
                        label="Email"
                        v-model="email"
                        class="w-full"/>

                    <vs-input
                        type="password"
                        name="password"
                        icon-no-border
                        icon="icon icon-lock"
                        icon-pack="feather"
                        label="Password"
                        v-model="password"
                        class="w-full mt-6" />

                    <div class="flex justify-center mt-8 sm:mt-2">
                      <div class="flex flex-wrap justify-between my-5">
                    </div>
                        <vs-checkbox v-model="checkbox_remember_me" class="mb-3 sm:mb-1">Recuerdame</vs-checkbox>
                    </div>
                    <div class="flex justify-center lg:mt-12 md:mt:-12 ">
                      <vs-button class="float-center" @click="login">Ingresar</vs-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      email: "",
      password: "",
      checkbox_remember_me: false,
    };
  },
  methods: {
    async login() {
      const { data } = await this.$http.post(`${process.env.apiRobocob}/api/auth/login`,
        {
          email: this.email,
          password: this.password,
        }
      );
      let token = data.access_token;
      if(token){
        localStorage.token = token;
        if (this.$route.path !== "/home") {
          this.$router.push("/home");
        }
      }else{
        this.$router.push('/').catch(()=>{})
      }
    },
  },
};
</script>

<style lang="scss">
.title{
  font-family: 'Montserrat';
  font-style: normal;
  color: #0E369E;
}
#page-login {
  .social-login-buttons {
    .bg-facebook { background-color: #1551b1 }
    .bg-twitter { background-color: #00aaff }
    .bg-google { background-color: #4285F4 }
    .bg-github { background-color: #333 }
  }
}
</style>
